"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CNTableBase = exports.adjustHeaderSize = undefined;

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _icon = require("@alicd/next/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require("babel-runtime/helpers/get");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _table = require("@alicd/next/lib/table");

var _table2 = _interopRequireDefault(_table);

var _nextDom = require("@alicd/next-dom");

var _classnames3 = require("classnames");

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findDOMNode = _reactDom2.default.findDOMNode;

// is monkey patch a good way to go?
//  not exactly, there is a HOC LocaleProvider
/* Table.prototype.cnTableGetSelectedRowKeys = function () {
 *     console.log(this);
 *     return this.state.selectedRowKeys;
 * };*/

var TableInner = _table2.default.prototype.render.call({
    _getInstance: function _getInstance() {},
    props: {} }).type;

function doAdjustHeaderSize() {
    var _this = this;

    if (this.isLock() && this.props.hasHeader) {
        this.state.groupChildren.forEach(function (child, index) {
            var lastIndex = _this.state.groupChildren[index].length - 1;
            var headerLeftRow = findDOMNode(_this.refs[_this.getHeaderRef(index, 0, false)]),
                headerRightRow = findDOMNode(_this.refs[_this.getHeaderRef(index, lastIndex, false)]),
                headerRightLockRow = findDOMNode(_this.refs[_this.getHeaderRef(index, 0, 'right')]),
                headerLeftLockRow = findDOMNode(_this.refs[_this.getHeaderRef(index, 0, 'left')]),
                headerRightLockRowHeight = 0,
                headerLeftLockRowHeight = 0;

            headerRightLockRow && _nextDom.style.set(headerRightLockRow, 'height', "auto");
            headerLeftLockRow && _nextDom.style.set(headerLeftLockRow, 'height', "auto");
            _nextDom.style.set(headerLeftRow, 'height', "auto");

            // 如果不需要锁列的出现，就不要在计算锁列的header的高度
            // 这在浏览器缩放的时候可能会造成高度计算的问题
            if (headerRightLockRow && !_this._notNeedAdjustLockRight) {
                headerRightLockRowHeight = getExactHeight(headerRightLockRow);
            }

            if (headerLeftLockRow && !_this._notNeedAdjustLockLeft) {
                headerLeftLockRowHeight = getExactHeight(headerLeftLockRow);
            }
            var maxLeftRowHeight = Math.max(headerLeftLockRowHeight, getExactHeight(headerLeftRow)),
                maxRightRowHeight = Math.max(headerRightLockRowHeight, getExactHeight(headerRightRow));
            _nextDom.style.set(headerLeftRow, 'height', maxLeftRowHeight);
            headerRightLockRow && _nextDom.style.set(headerRightLockRow, 'height', maxRightRowHeight);
            headerLeftLockRow && _nextDom.style.set(headerLeftLockRow, 'height', maxLeftRowHeight);
        });
    }
}

function _adjustHeaderSize() {
    doAdjustHeaderSize.call(this);
}

exports.adjustHeaderSize = _adjustHeaderSize;
function getExactHeight(e) {
    return e.getBoundingClientRect().height;
}

var CNTableBaseInner = function (_TableInner) {
    (0, _inherits3.default)(CNTableBaseInner, _TableInner);

    function CNTableBaseInner() {
        (0, _classCallCheck3.default)(this, CNTableBaseInner);
        return (0, _possibleConstructorReturn3.default)(this, (CNTableBaseInner.__proto__ || (0, _getPrototypeOf2.default)(CNTableBaseInner)).apply(this, arguments));
    }

    (0, _createClass3.default)(CNTableBaseInner, [{
        key: "adjustIfTableNotNeedLock",
        value: function adjustIfTableNotNeedLock() {
            var _this3 = this;

            if (this.isLock() && this.state.dataSource.length) {
                var configWidths = this.state.flatChildren.map(function (item, index) {
                    var row = findDOMNode(_this3.refs[_this3.getCellRef(0, index)]);

                    // when lock and no dataSource, the row is undefined
                    // you need to getHeaderRef instead of getCellRef
                    if (!row && _this3.state.dataSource.length === 0) {
                        var rowHeader = findDOMNode(_this3.refs[_this3.getHeaderRef(0, index)]);
                        return rowHeader && rowHeader.clientWidth || 0;
                    }
                    return row && row.clientWidth || 0;
                }).reduce(function (a, b) {
                    return a + b;
                }, 0);
                var node = findDOMNode(this);
                var width = node.clientWidth;
                if (configWidths <= width) {
                    var counter = !!this.state.lockLeftChildren.length + !!this.state.lockRightChildren.length;

                    // reset header height when disabling lock
                    // CASE: transition from isLock to notLock (because of change in Columns etc.)
                    //  the height style is not removed and header might be too high
                    var callback = function callback() {
                        counter -= 1;
                        if (!counter) {
                            _this3.state.groupChildren.forEach(function (child, index) {
                                var headerRow = findDOMNode(_this3.refs[_this3.getHeaderRef(index, 0, false)]);
                                _nextDom.style.set(headerRow, 'height', "auto");
                            });
                        }
                    };

                    if (this.state.lockLeftChildren.length) {
                        this.setState({
                            lockLeftChildren: []
                        }, callback);
                        this._notNeedAdjustLockLeft = true;
                    }
                    if (this.state.lockRightChildren.length) {
                        this.setState({
                            lockRightChildren: []
                        }, callback);
                        this._notNeedAdjustLockRight = true;
                    }
                }
            }
        }
    }, {
        key: "setLeftCellSize",
        value: function setLeftCellSize(index, i) {
            var lockLeftRow = findDOMNode(this.refs[this.getCellRef(index, i, 'left')]),
                row = this.getRowDOMNode(index, i),
                expandedRow = findDOMNode(this.refs[this.getExpandedCellRef(index, i, false)]),
                lockLeftExpandedRow = findDOMNode(this.refs[this.getExpandedCellRef(index, i, 'left')]),
                rowHeight = row && getExactHeight(row) || 0;
            var expandedRowHeight = 0,
                lockLeftHeight = 0;

            if (lockLeftRow) {
                lockLeftHeight = getExactHeight(lockLeftRow);
            }
            if (expandedRow) {
                expandedRowHeight = getExactHeight(expandedRow);
            }
            lockLeftExpandedRow && _nextDom.style.set(lockLeftExpandedRow, 'height', expandedRowHeight + "px");
            if (lockLeftRow && rowHeight !== lockLeftHeight) {
                _nextDom.style.set(lockLeftRow, 'height', rowHeight + "px");
            }
        }
    }, {
        key: "setRightCellSize",
        value: function setRightCellSize(index, i) {
            var lockRightStart = this.state.flatChildren.length - this.state.lockRightChildren.length;
            var lockRightRow = findDOMNode(this.refs[this.getCellRef(index, lockRightStart + i, 'right')]),
                row = this.getRowDOMNode(index, lockRightStart + i),
                expandedRow = findDOMNode(this.refs[this.getExpandedCellRef(index, i, false)]),
                lockRightExpandedRow = findDOMNode(this.refs[this.getExpandedCellRef(index, i, 'right')]),
                rowHeight = row && getExactHeight(row) || 0;
            var lockRightHeight = 0,
                expandedRowHeight = 0;

            if (lockRightRow) {
                lockRightHeight = getExactHeight(lockRightRow);
            }
            if (expandedRow) {
                expandedRowHeight = getExactHeight(expandedRow);
            }
            lockRightExpandedRow && _nextDom.style.set(lockRightExpandedRow, 'height', expandedRowHeight + "px");
            if (lockRightRow && rowHeight !== lockRightRow) {
                _nextDom.style.set(lockRightRow, 'height', rowHeight + "px");
            }
        }
    }, {
        key: "adjustHeaderSize",
        value: function adjustHeaderSize() {
            return _adjustHeaderSize.call(this);
        }
    }, {
        key: "renderSelectionNode",
        value: function renderSelectionNode() {
            var column = (0, _get3.default)(CNTableBaseInner.prototype.__proto__ || (0, _getPrototypeOf2.default)(CNTableBaseInner.prototype), "renderSelectionNode", this).call(this);
            if (this.props.rowSelection && this.props.rowSelection.lock) {
                column.lock = true;
            }
            return column;
        }
    }, {
        key: "renderExpandedNode",
        value: function renderExpandedNode() {
            var column = (0, _get3.default)(CNTableBaseInner.prototype.__proto__ || (0, _getPrototypeOf2.default)(CNTableBaseInner.prototype), "renderExpandedNode", this).call(this);
            if (this.props.lockExpandedRowCtrl) {
                column.lock = true;
            }
            return column;
        }
    }, {
        key: "renderSelectionCell",
        value: function renderSelectionCell(type) {
            var _this4 = this;

            var ret = (0, _get3.default)(CNTableBaseInner.prototype.__proto__ || (0, _getPrototypeOf2.default)(CNTableBaseInner.prototype), "renderSelectionCell", this).call(this, type);
            return function (value, index, record) {
                var org = ret(value, index, record);
                if (type === "header" && (_this4.props.rowSelection.mode || "multiple") === "multiple") {
                    return React.cloneElement(org, {
                        checked: org.props.checked && !!_this4.props.dataSource.length,
                        disabled: org.props.disabled || !_this4.props.dataSource.length
                    });
                }
                return org;
            };
        }
    }, {
        key: "renderRow",
        value: function renderRow(flatChildren, record, index, lock) {
            var _this5 = this,
                _classnames;

            index = index + this._lastChildrenLength;
            var _props = this.props,
                getRowClassName = _props.getRowClassName,
                getRowProps = _props.getRowProps,
                primaryKey = _props.primaryKey,
                isTree = _props.isTree,
                prefix = this.getPrefix(),
                _state = this.state,
                openRowKeys = _state.openRowKeys,
                dataSource = _state.dataSource,
                selectedRowKeys = _state.selectedRowKeys,
                colGroups = [],
                listHeader = this.renderListGroupHeader(record, index),
                col = flatChildren.map(function (child, i) {
                var cell = _this5.renderCell(record, child, index, i, lock, flatChildren.length, listHeader);
                colGroups.push(cell.col);
                return cell.node;
            }),
                expandedRow = void 0,
                treeNodeStatus = this.getTreeNodeStatus(dataSource);


            expandedRow = this.renderExpandedRow(record, index, flatChildren.length, lock);
            if (expandedRow) {
                expandedRow = React.cloneElement(expandedRow, {
                    onClick: this._onExpandedRowClick.bind(this, record, index)
                });
            }
            var className = getRowClassName(record, index),
                otherProps = getRowProps(record, index),
                cls = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, prefix + "table-row", true), (0, _defineProperty3.default)(_classnames, "last", index === dataSource.length - 1), (0, _defineProperty3.default)(_classnames, "first", index === 0), (0, _defineProperty3.default)(_classnames, "hidden", isTree && !(treeNodeStatus.indexOf(record[primaryKey]) > -1) && record.__level !== 0), (0, _defineProperty3.default)(_classnames, prefix + "table-row-level-" + record.__level, isTree), (0, _defineProperty3.default)(_classnames, "opened", openRowKeys.indexOf(record[primaryKey]) > -1), (0, _defineProperty3.default)(_classnames, "selected", !listHeader && selectedRowKeys.indexOf(record[primaryKey]) > -1), (0, _defineProperty3.default)(_classnames, className, className), _classnames));

            var row = {};
            /* eslint-disable eqeqeq */
            // really a big, horrible monkey hack ...
            var rowKey = record[primaryKey] != null && record[primaryKey] !== '' ? record[primaryKey] : index;
            if (listHeader) {
                if (record.children && record.children.length) {
                    colGroups = [];
                    col = record.children.map(function (item, childIndex) {
                        var td = flatChildren.map(function (child, i) {
                            var cell = _this5.renderCell(item, child, index + childIndex + 1, i, lock, flatChildren.length);
                            if (colGroups.length !== flatChildren.length) {
                                colGroups.push(cell.col);
                            }
                            return cell.node;
                        });
                        return React.createElement(
                            "tr",
                            { key: childIndex },
                            td
                        );
                    });
                    this._lastChildrenLength += record.children.length;
                } else {
                    col = React.createElement(
                        "tr",
                        { key: index },
                        col
                    );
                }
                row.node = React.createElement(
                    "table",
                    (0, _extends3.default)({}, otherProps, { className: cls, key: rowKey, onClick: this._onRowClick.bind(this, record, index),
                        onMouseEnter: this._onRowHover.bind(this, record, index, true),
                        onMouseLeave: this._onRowHover.bind(this, record, index, false) }),
                    React.createElement(
                        "colgroup",
                        null,
                        colGroups
                    ),
                    React.createElement(
                        "tbody",
                        null,
                        listHeader,
                        col,
                        expandedRow
                    )
                );
            } else {
                row.node = [React.createElement(
                    "tr",
                    (0, _extends3.default)({}, otherProps, { className: cls, key: rowKey, onClick: this._onRowClick.bind(this, record, index), ref: this.getRowRef(index, lock),
                        onMouseEnter: this._onRowHover.bind(this, record, index, true),
                        onMouseLeave: this._onRowHover.bind(this, record, index, false) }),
                    col
                ), expandedRow];
                row.needWrapper = true;
            }
            row.colGroups = colGroups;
            return row;
        }
    }, {
        key: "renderCell",
        value: function renderCell(record, props, index, i, lock, flatChildrenLength, listGroup) {
            var _classnames2;

            if (lock === 'right') {
                i = i + (this.state.flatChildren.length - this.state.lockRightChildren.length);
            }
            var value = getDataByPath(record, props.dataIndex),
                cellProps = { value: value, index: index, record: record, context: this },
                content = void 0,
                style = void 0,
                align = props.align,
                _props2 = this.props,
                getCellProps = _props2.getCellProps,
                indentSize = _props2.indentSize,
                primaryKey = _props2.primaryKey,
                isTree = _props2.isTree,
                prefix = this.getPrefix(),
                ref = this.getCellRef(index, i, lock),
                attrs = getCellProps(index, i, record) || {},
                firstCellStyle = void 0,
                treeArrowNode = void 0;


            if (React.isValidElement(props.cell)) {
                content = React.cloneElement(props.cell, cellProps);
            } else if (typeof props.cell === 'function') {
                content = props.cell(value, index, record, this);
            }
            if (props.width) {
                style = {
                    width: props.width
                };
            }

            if (this.notRenderCellIndex && !listGroup) {
                var matchCellIndex = this.notRenderCellIndex.map(function (cellIndex) {
                    return cellIndex.toString();
                }).indexOf([index, i].toString());
                if (matchCellIndex > -1) {
                    this.notRenderCellIndex.splice(matchCellIndex, 1);
                    return {
                        node: null,
                        col: React.createElement("col", { style: style, key: index + "_" + i })
                    };
                }
            }

            if (attrs.colSpan && attrs.colSpan > 1 || attrs.rowSpan && attrs.rowSpan > 1) {
                if (lock) {
                    this.rowSpanLock = true;
                }
                this._getNotRenderCellIndex(i, index, attrs.colSpan || 1, attrs.rowSpan || 1);
            }

            var cls = (0, _classnames4.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, props.className, props.className), (0, _defineProperty3.default)(_classnames2, prefix + "table-cell", true), (0, _defineProperty3.default)(_classnames2, "first", lock !== 'right' && i === 0), (0, _defineProperty3.default)(_classnames2, "last", lock !== 'left' && (i === flatChildrenLength - 1 || i + attrs.colSpan === flatChildrenLength)), _classnames2));

            var treeArrowNodeIndex = (this.props.rowSelection ? 1 : 0) + this.props.treeArrowIndent;

            if (isTree && lock !== 'right' && i === treeArrowNodeIndex) {
                firstCellStyle = {
                    paddingLeft: indentSize * (record.__level + 1)
                };
                treeArrowNode = React.createElement(_icon2.default, { size: "xs", className: prefix + "table-tree-placeholder" });

                var treeArrowState = void 0;

                if (record.children && record.children.length) {
                    if (this.state.openRowKeys.indexOf(record[primaryKey]) > -1) {
                        treeArrowState = 'open';
                    } else {
                        treeArrowState = 'close';
                    }
                    treeArrowNode = React.createElement(_icon2.default, {
                        className: "cn-table-tree-arrow cn-table-tree-arrow-" + treeArrowState,
                        type: "arrow-down",
                        size: "xs",
                        onClick: this.onTreeNodeClick.bind(this, record)
                    });
                }
            }

            var cellStyle = (0, _extends3.default)({}, props.style);

            if (typeof align !== 'undefined') {
                cellStyle.textAlign = align;
            }

            return {
                node: React.createElement(
                    "td",
                    (0, _extends3.default)({ className: cls, style: cellStyle, ref: ref, key: index + "_" + i }, attrs),
                    React.createElement(
                        "div",
                        { className: prefix + "table-cell-wrapper", style: firstCellStyle },
                        treeArrowNode,
                        content
                    )
                ),
                col: React.createElement("col", { style: style, key: index + "_" + i })
            };
        }
    }]);
    return CNTableBaseInner;
}(TableInner);

function getDataByPath(object, path) {
    if (!object || !path) {
        return false;
    }
    path = path.toString();
    var field = path.split('.'),
        val = void 0,
        key = void 0;
    if (field.length) {
        key = field[0];
        //lists[1].name
        if (key.indexOf('[') >= 0) {
            key = key.match(/(.*)\[(.*)\]/);
            if (key) {
                val = object[key[1]][key[2]];
            }
        } else {
            val = object[field[0]];
        }
        if (val) {
            for (var i = 1; i < field.length; i++) {
                val = val[field[i]];
                if (typeof val === 'undefined') {
                    break;
                }
            }
        }
    }
    return val;
}

var CNTableBase = exports.CNTableBase = (0, _localeProvider2.default)(CNTableBaseInner);
CNTableBase.LOCALE = _table2.default.LOCALE;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/Monkey.js
// module id = 697
// module chunks = 0